<template>
  <div class="my-register-page">
    <div class="my-container">
      <b-row class="mb-2 align-items-center">
        <b-col>
          <h1>{{ $t("Xabarnoma") }}</h1>
        </b-col>
      </b-row>

      <!-- Yuqoridagi 4 ta kartochka -->
      <div class="xn-summary">
        <div class="xn-summary__item">
          <div class="xn-summary__count">{{ Summary.total || 0 }}</div>
          <div class="xn-summary__label">{{ $t("XabarnomaTotal") }}</div>
        </div>
        <div class="xn-summary__item xn-summary__item--unread">
          <div class="xn-summary__count">{{ Summary.unread || 0 }}</div>
          <div class="xn-summary__label">{{ $t("XabarnomaUnread") }}</div>
        </div>
        <div class="xn-summary__item xn-summary__item--awaiting">
          <div class="xn-summary__count">{{ Summary.awaitingReply || 0 }}</div>
          <div class="xn-summary__label">
            {{ $t("XabarnomaAwaitingReply") }}
          </div>
        </div>
        <div class="xn-summary__item xn-summary__item--replied">
          <div class="xn-summary__count">{{ Summary.replied || 0 }}</div>
          <div class="xn-summary__label">{{ $t("XabarnomaReplied") }}</div>
        </div>
      </div>

      <!-- Yo'nalish tablari -->
      <div class="xn-chips mt-3">
        <button
          class="xn-chip"
          :class="{ 'xn-chip--active': filter.direction === null }"
          @click="SelectDirection(null)"
        >
          {{ $t("XabarnomaAll") }}
        </button>
        <button
          class="xn-chip"
          :class="{ 'xn-chip--active': filter.direction === 'in' }"
          @click="SelectDirection('in')"
        >
          {{ $t("XabarnomaIncoming") }} · {{ Summary.inCount || 0 }}
        </button>
        <button
          class="xn-chip"
          :class="{ 'xn-chip--active': filter.direction === 'out' }"
          @click="SelectDirection('out')"
        >
          {{ $t("XabarnomaOutgoing") }} · {{ Summary.outCount || 0 }}
        </button>
      </div>

      <!-- Turlar bo'yicha chiplar (faqat kiruvchilarga tegishli) -->
      <div class="xn-chips mt-2" v-if="filter.direction !== 'out'">
        <button
          class="xn-chip"
          :class="{ 'xn-chip--active': filter.typeId === null }"
          @click="SelectType(null)"
        >
          {{ $t("XabarnomaAllTypes") }}
        </button>
        <button
          v-for="type in TypeChips"
          :key="type.typeId"
          class="xn-chip"
          :class="{ 'xn-chip--active': filter.typeId === type.typeId }"
          @click="SelectType(type.typeId)"
        >
          {{ type.typeName }} · {{ type.count }}
        </button>
      </div>

      <b-row class="mt-3 align-items-center">
        <b-col cols="12" md="6">
          <custom-input
            v-model="filter.search"
            :label="''"
            :placeholder="$t('XabarnomaSearchPlaceholder')"
            @keyup="SearchDelayed"
          />
        </b-col>
        <b-col cols="12" md="6" class="text-md-right mt-2 mt-md-0">
          <span class="text-muted">
            {{ filter.totalRows }} {{ $t("XabarnomaResultCount") }}
          </span>
        </b-col>
      </b-row>

      <b-overlay :show="Loading">
        <b-table-simple bordered responsive class="mt-3">
          <b-thead>
            <b-tr variant="primary">
              <b-th style="vertical-align: middle">№</b-th>
              <b-th style="vertical-align: middle">{{ $t("Xabarnoma") }}</b-th>
              <b-th style="vertical-align: middle">
                {{ $t("XabarnomaSender") }}
              </b-th>
              <b-th style="vertical-align: middle">{{ $t("docDate") }}</b-th>
              <b-th style="vertical-align: middle">{{ $t("status") }}</b-th>
              <b-th
                style="vertical-align: middle; width: 80px"
                class="text-center"
              >
                {{ $t("actions") }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(item, index) in Rows"
              :key="item.recipientId + '-' + index"
              style="cursor: pointer"
              @click="View(item)"
            >
              <b-td class="text-nowrap">
                {{ (filter.page - 1) * filter.pageSize + index + 1 }}
              </b-td>
              <b-td>
                <div class="xn-row-type">
                  <span class="xn-dot" v-if="IsUnread(item)"></span>
                  {{ item.typeName }}
                </div>
                <div class="xn-row-subject">{{ item.subject }}</div>
              </b-td>
              <b-td>{{ item.counterpartName }}</b-td>
              <b-td class="text-nowrap">{{ item.date }}</b-td>
              <b-td class="text-nowrap">
                <span
                  class="xn-status"
                  :class="'xn-status--' + StatusVariant(item.statusId)"
                >
                  {{ item.statusLabel }}
                </span>
              </b-td>
              <b-td class="text-center">
                <b-link class="xn-view-btn" :title="$t('view')">
                  <b-icon icon="eye" font-scale="1.2"></b-icon>
                </b-link>
              </b-td>
            </b-tr>
            <b-tr v-if="!Rows.length">
              <b-td colspan="6" class="text-center text-muted">
                {{ $t("noData") }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-overlay>

      <div>
        <b-pagination
          v-model="filter.page"
          :total-rows="filter.totalRows"
          :per-page="filter.pageSize"
          first-number
          last-number
          @input="Refresh"
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <b-icon icon="chevron-double-left" size="18" />
          </template>
          <template #next-text>
            <b-icon icon="chevron-double-right" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BOverlay,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BPagination,
  BIcon,
  BLink,
} from "bootstrap-vue";
import customInput from "@/components/elements/customInput.vue";
import XabarnomaService from "@/services/xabarnoma.service";

export default {
  components: {
    BRow,
    BCol,
    BOverlay,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BPagination,
    BIcon,
    BLink,
    customInput,
  },
  data() {
    return {
      Loading: false,
      Rows: [],
      Types: [],
      Summary: {},
      searchTimer: null,
      filter: {
        search: "",
        direction: null,
        typeId: null,
        page: 1,
        pageSize: 20,
        totalRows: 0,
      },
    };
  },
  created() {
    XabarnomaService.GetTypes()
      .then((res) => {
        this.Types = res.data || [];
      })
      .catch(() => {
        this.Types = [];
      });
    this.Refresh();
  },
  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },
  computed: {
    // Sonlar Summary.byType'dan keladi; GetTypes esa hech bo'lmasa turlar
    // nomini beradi — shuning uchun ikkalasini birlashtiramiz.
    TypeChips() {
      const byType = this.Summary.byType || [];
      if (byType.length) return byType;
      return this.Types.map((t) => ({
        typeId: t.id,
        typeName: t.name,
        count: 0,
      }));
    },
  },
  methods: {
    IsUnread(item) {
      // 1=Yuborildi, 2=Yetkazildi — ya'ni hali o'qilmagan kiruvchi xabarnoma
      return item.isIncoming && (item.statusId === 1 || item.statusId === 2);
    },
    StatusVariant(statusId) {
      switch (statusId) {
        case 1:
        case 2:
          return "new";
        case 3:
          return "read";
        case 4:
          return "awaiting";
        case 5:
          return "replied";
        case 6:
          return "expired";
        default:
          return "default";
      }
    },
    SelectDirection(direction) {
      if (this.filter.direction === direction) return;
      this.filter.direction = direction;
      if (direction === "out") this.filter.typeId = null;
      this.filter.page = 1;
      this.Refresh();
    },
    SelectType(typeId) {
      if (this.filter.typeId === typeId) return;
      this.filter.typeId = typeId;
      this.filter.page = 1;
      this.Refresh();
    },
    SearchDelayed() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.filter.page = 1;
        this.Refresh();
      }, 500);
    },
    View(item) {
      if (!item || !item.recipientId) return;
      this.$router.push({
        name: "XabarnomaView",
        params: { id: item.recipientId },
      });
    },
    Refresh() {
      this.Loading = true;
      XabarnomaService.GetList(this.filter)
        .then((res) => {
          const data = res.data || {};
          this.Rows = data.rows || [];
          this.Summary = data.summary || {};
          this.filter.totalRows = data.totalCount || 0;
          this.Loading = false;
        })
        .catch((error) => {
          this.Loading = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400 && message.errors) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.xn-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;

  @media screen and (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.xn-summary__item {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 16px;
  background: #f7f7f7;

  &--unread {
    background: #fff7e8;
    border-color: #f5dfb5;
    .xn-summary__count {
      color: #b4740e;
    }
  }
  &--awaiting {
    background: #eaf2ff;
    border-color: #cddfff;
    .xn-summary__count {
      color: $primary;
    }
  }
  &--replied {
    background: #e9f7ef;
    border-color: #c3e7d2;
    .xn-summary__count {
      color: #1a7f47;
    }
  }
}

.xn-summary__count {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.xn-summary__label {
  font-size: 13px;
  color: #6b7280;
}

.xn-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.xn-chip {
  border: 1.5px solid #d1d5db;
  background: #fff;
  color: #374151;
  border-radius: 20px;
  padding: 7px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background-color 0.2s;

  &:hover {
    border-color: $primary;
    color: $primary;
  }

  &--active {
    background: $primary-dark;
    border-color: $primary-dark;
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
}

.xn-row-type {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: $primary;
  display: flex;
  align-items: center;
  gap: 6px;
}

.xn-row-subject {
  font-weight: 600;
}

.xn-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $danger;
  display: inline-block;
}

.xn-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  background: #f0f0f0;
  color: #4b5563;

  &--new {
    background: #fff7e8;
    color: #b4740e;
  }
  &--read {
    background: #f0f0f0;
    color: #4b5563;
  }
  &--awaiting {
    background: #eaf2ff;
    color: $primary;
  }
  &--replied {
    background: #e9f7ef;
    color: #1a7f47;
  }
  &--expired {
    background: #fdeaef;
    color: $danger;
  }
}

.xn-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: $primary;
  background: #eaf2ff;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;

  &:hover {
    background: $primary;
    color: #fff;
  }
}
</style>
